import type { ThemeTemplate } from './templates';

export const templateC: ThemeTemplate = {
  id: 'C',
  name: '大猫集团风',
  layoutMode: 'damao',
  tagline: '不是所有团建都配叫大客户体验',
  description: '全屏视差Hero · 横向卡片流 · 粗体大字排版 · 暗色高级感',
  primary: '#0D0D0D',
  accent: '#D4A853',
  background: '#F8F6F0',
  secondary: '#1A1A1A',
  textPrimary: '#1A1A1A',
  textSecondary: '#757575',
  heroGradient: 'linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.85) 100%)',
  cardBg: '#FFFFFF',
  cardBorderRadius: 4,
  buttonBorderRadius: 2,
  buttonStyle: 'square',
  fontFamily: '"Noto Sans SC", "PingFang SC", system-ui, sans-serif',
  navBg: 'rgba(13,13,13,0.96)',
  navText: '#FFFFFF',
  footerBg: '#0D0D0D',
  footerText: '#9E9E9E',
  preview: { primary: '#0D0D0D', accent: '#D4A853', background: '#F8F6F0' },
};
